<template>
  <div class="requirement-details">
    <div class="section">
      <!-- draft=草稿,release=发布/验样阶段,wait_order=待发起订单,bidding=竞价阶段,repurchase_bidding=复购竞价,completed=已完成,close=关闭 -->
      <div v-if="demandType == 'apply_verify' && orderListObj?.applyVerify?.applyStatus == 'apply'">
        <div class="status-header">
          <div class="status-title">验样中</div>
          <button class="status-btn" @click="openTerminateDialog">终止</button>
        </div>

        <div class="status-sub">
          <div class="status-hint">请耐心等待采购方验样结果</div>
          <div class="status-time">提交时间：{{ orderListObj.createTime }}</div>
        </div>
      </div>

      <div v-if="demandType == 'apply_verify' && orderListObj?.applyVerify?.applyStatus == 'not_pass'">
        <div class="status-header">
          <div class="status-title">验样未通过</div>
        </div>
        <div class="status-sub">
          <div class="status-hint">很遗憾，验样未通过，原因：{{ orderListObj?.applyVerify?.auditExplain || "无" }}</div>
          <div class="status-time">提交时间：{{ orderListObj.applyVerify.createTime }}</div>
        </div>
      </div>

      <div v-if="demandType == 'bidding' && orderListObj?.applyVerify?.applyStatus == 'pass' && !biddingIdAD && orderListObj?.bidding?.biddingStatus != 'bidding'">
        <div class="status-header">
          <div class="status-title">待竞价（待你提交竞价）</div>
          <button class="status-btn" @click="openBiddingDialog">提交竞价</button>
        </div>
        <div class="status-sub">
          <div class="status-hint">恭喜你验样通过，请提交竞价表单</div>
          <div class="status-time">提交时间：{{ orderListObj.applyVerify.createTime || "" }}</div>
        </div>
      </div>

      <div v-if="demandType == 'bidding' && orderListObj?.bidding?.biddingStatus == 'bidding'">
        <div class="status-header">
          <div class="status-title">竞价中</div>
          <div>
            <button v-if="orderListObj?.bidding" class="status-btn" style="border: 1px solid #1869ff; color: #1869ff; background: #fff" @click="handleCloseBidding">终止</button>
            <button v-if="orderListObj?.bidding && orderListObj.bidding.biddingStatus != 'pass'" class="status-btn" style="margin-left: 14px" @click="openBiddingDialog2">修改竞价</button>
          </div>
        </div>
        <div class="status-sub">
          <div class="status-hint">采购方正在比价中，请耐心等候采购方反馈竞价结果</div>
          <div class="status-time">提交时间：{{ orderListObj.bidding.createTime }}</div>
        </div>
      </div>

      <div v-if="demandType == 'bidding' && biddingInfoAD?.biddingStatus == 'not_pass'">
        <div class="status-header">
          <div class="status-title">竞价未通过</div>
        </div>
        <div class="status-sub">
          <div class="status-hint">很遗憾，竞价未通过，原因：{{ biddingInfoAD?.auditExplain || "无" }}</div>
          <div class="status-time">提交时间：{{ biddingInfoAD?.createTime }}</div>
        </div>
      </div>

      <div v-if="demandType == 'bidding' && biddingInfoAD?.biddingStatus == 'completed'">
        <div class="status-header">
          <div class="status-title">已完成</div>
        </div>
        <div class="status-sub">
          <div class="status-hint">恭喜你，已中标</div>
          <div class="status-time">提交时间：{{ biddingInfoAD.createTime }}</div>
        </div>
      </div>
      <div v-if="demandType == 'apply_verify' && orderListObj?.applyVerify?.applyStatus == 'close' && !biddingIdAD">
        <div class="status-header">
          <div class="status-title">验样已终止</div>
        </div>
        <div class="status-sub">
          <div class="status-hint">申请已终止，原因：{{ orderListObj.closeExplain || "无" }}</div>
          <div class="status-time">提交时间：{{ orderListObj.createTime || "" }}</div>
        </div>
      </div>

      <div v-if="biddingInfoAD?.biddingStatus == 'close'">
        <div class="status-header">
          <div class="status-title">竞价已终止</div>
        </div>
        <div class="status-sub">
          <div class="status-hint">申请已终止，原因：{{ biddingInfoAD.closeExplain || "无" }}</div>
          <div class="status-time">提交时间：{{ biddingInfoAD.createTime || "" }}</div>
        </div>
      </div>

      <!-- 订单分组 -->
      <div class="order-group">
        <div class="order-id">ID: {{ orderListObj.demandId }}</div>
        <div class="table-row table-body">
          <div class="cell cell-a">
            <img class="avatar" :src="avatarImg" alt="avatar" />
            <span class="publisher-name">{{ orderListObj?.applyVerify?.relationName || "无" }}</span>
          </div>
          <div class="cell cell-b">
            <img v-if="productFirstImage" :src="productFirstImage" class="product-img" />
            <div v-else>无产品图</div>
          </div>
          <div class="cell cell-c">{{ orderListObj.productName || "无" }}</div>
          <div class="cell cell-d">{{ orderListObj.productType || "无" }}</div>
          <div class="cell cell-e">{{ orderListObj?.applyVerify?.enterpriseName || "无" }}</div>
          <div class="cell cell-f">{{ orderListObj.relationPhone }}</div>
          <div class="cell cell-g">{{ orderListObj.productRemark }}</div>
          <div class="cell cell-action" v-if="canViewOrderDetail">
            <button type="button" class="order-detail-btn" @click="openOrderDetailDialog">订单详情</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 竞价中人员（供应商可查看竞争对手竞价，联系方式已脱敏） -->
    <div class="section" v-if="demandType === 'bidding' || biddingPersonList.length">
      <div style="display: flex; align-items: center; justify-content: space-between">
        <div class="section-title">
          <span class="title-bar"></span>
          <div class="title-text">竞价中人员</div>
          <span class="title-text-num">（共{{ biddingPersonList.length }}个）</span>
        </div>
        <div v-show="biddingPersonList.length >= 1" style="color: #1869ff; cursor: pointer; user-select: none" @click="isShowBiddingMore = !isShowBiddingMore">
          {{ isShowBiddingMore ? "收起" : "展开" }}
        </div>
      </div>
      <div class="person-list" v-if="biddingPersonList.length">
        <div v-for="(person, index) in biddingPersonList" :key="index" class="person-item" v-show="isShowBiddingMore">
          <div class="person-company">{{ person.enterpriseName || person.relationName || person.userName || "无" }}</div>
          <div class="person-phone">
            <img class="phone-icon" src="@/assets/image/iconPhone.png" alt="phone" />
            <span>{{ person.relationPhone || "无" }}</span>
          </div>
          <div class="person-time">竞价时间：{{ person.createTime }}</div>
        </div>
      </div>
      <div v-else style="margin-top: 8px; color: #999">暂无其他竞价</div>
    </div>
    <!-- 已申请验样人员 -->
    <div class="section">
      <div style="display: flex; align-items: center; justify-content: space-between">
        <div class="section-title">
          <span class="title-bar"></span>
          <div class="title-text">已申请验样人员</div>
          <span class="title-text-num">（共{{ personList.length }}个）</span>
        </div>
        <div v-show="personList.length >= 1" style="color: #1869ff; cursor: pointer; user-select: none" @click="isShowMore = !isShowMore">{{ isShowMore ? "收起" : "展开" }}</div>
      </div>
      <div class="person-list">
        <div v-for="(person, index) in personList" :key="index" class="person-item" v-show="isShowMore">
          <div class="person-company">{{ person.enterpriseName }}</div>
          <div class="person-phone">
            <img class="phone-icon" src="@/assets/image/iconPhone.png" alt="phone" />
            <span>{{ person.relationPhone }}</span>
          </div>
          <div class="person-time">申请时间：{{ person.createTime }}</div>
        </div>
      </div>
    </div>

    <!-- 验样信息 -->
    <div class="section">
      <div class="section-title">
        <span class="title-bar"></span>
        <span class="title-text">验样信息</span>
      </div>
      <div class="info-content">
        <div class="info-row">
          <span class="info-label">申请信息：</span>
          <span class="info-link" @click="handleViewApply">查看</span>
        </div>
        <div class="info-row">
          <span class="info-label">备注：</span>
          <span class="info-value">{{ orderListObj?.applyVerify?.applyRemark || "无" }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">申请时间：</span>
          <span class="info-value">{{ orderListObj?.applyVerify?.createTime || "无" }}</span>
        </div>

        <div class="info-row" v-if="orderListObj?.applyVerify?.applyStatus != 'apply'">
          <span class="info-label">审核结果：</span>
          <span class="info-value">{{ getApplyStatusLabel(orderListObj?.applyVerify?.applyStatus) }}</span>
        </div>

        <div class="info-row" v-if="orderListObj?.applyVerify?.applyStatus != 'apply'">
          <span class="info-label">审核时间：</span>
          <span class="info-value">{{ orderListObj?.applyVerify?.auditTime || "无" }}</span>
        </div>
      </div>
    </div>

    <!-- 竞价信息 -->
    <div class="section" v-if="biddingIdAD">
      <div class="section-title">
        <span class="title-bar"></span>
        <span class="title-text">竞价信息</span>
      </div>
      <div class="info-content">
        <div class="info-row">
          <span class="info-label">竞价详情：</span>
          <span class="info-link" @click="handleViewBidding">查看</span>
        </div>
        <div class="info-row">
          <span class="info-label">备注：</span>
          <span class="info-value">{{ biddingInfoAD.biddingRemark || "无" }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">提交时间：</span>
          <span class="info-value">{{ biddingInfoAD.createTime || "无" }}</span>
        </div>
        <div class="info-row" v-if="biddingInfoAD.biddingStatus != 'bidding'">
          <span class="info-label">审核结果：</span>
          <span class="info-value">{{ getBiddingStatusLabel(biddingInfoAD.biddingStatus) }}</span>
        </div>
        <div class="info-row" v-if="biddingInfoAD.biddingStatus != 'bidding'">
          <span class="info-label">审核时间：</span>
          <span class="info-value">{{ biddingInfoAD.auditTime || "无" }}</span>
        </div>
      </div>
    </div>

    <!-- 终止验样申请确认弹窗 -->
    <ResultDialog
      :visible.sync="showTerminateDialog"
      title="终止提示"
      subtitle="你确定要终止验样申请吗？"
      :icon-src="require('@/assets/image/question-mark.png')"
      :dialog-width="'420px'"
      confirm-text="确定"
      cancel-text="取消"
      @confirm="handleTerminateConfirm"
      @cancel="showTerminateDialog = false"
      @close="closeTerminateDialog"
      btnMarginTop="35px"
    >
      <template #default>
        <div style="padding: 0 23px">
          <el-input resize="none" style="font-family: initial; font-size: 16px" type="textarea" :rows="6" placeholder="请输入终止理由" v-model="terminateReason"> </el-input>
        </div>
      </template>
    </ResultDialog>

    <!-- 验样申请信息详情弹窗 -->
    <el-dialog
      top="8vh"
      :append-to-body="true"
      :visible.sync="showApplyDetailDialog"
      width="808px"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="publish-demand-dialog"
      @close="applyDetailInfo = {}"
    >
      <div class="publish-modal" style="padding-bottom: 56px">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="showApplyDetailDialog = false" />
        <h3 class="publish-title">验样申请信息</h3>
        <div style="color: #1869ff; text-align: center; margin-top: 7px; font-size: 16px">
          <span v-if="applyDetailInfo.applyStatus == 'apply'">已申请</span>
          <span v-else-if="applyDetailInfo.applyStatus == 'pass'">已通过</span>
          <span v-else-if="applyDetailInfo.applyStatus == 'not_pass'">未通过</span>
          <span v-else-if="applyDetailInfo.applyStatus == 'close'">已终止</span>
        </div>
        <div class="info-pop-box">
          <div class="row-box">
            <div class="row-label">企业名称：</div>
            <div class="row-value">{{ applyDetailInfo.enterpriseName || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">联系人：</div>
            <div class="row-value">{{ applyDetailInfo.relationName || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">联系方式：</div>
            <div class="row-value">{{ applyDetailInfo.relationPhone || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">职务：</div>
            <div class="row-value">{{ applyDetailInfo.postName || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">微信号：</div>
            <div class="row-value">{{ applyDetailInfo.wxNumber || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">E-mail：</div>
            <div class="row-value">{{ applyDetailInfo.mail || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">地址：</div>
            <div class="row-value">{{ applyDetailInfo.address || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">备注：</div>
            <div class="row-value">{{ applyDetailInfo.applyRemark || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">营业执照：</div>
            <div class="row-value">
              <template v-if="applyDetailLicenseList.length > 0">
                <el-image v-for="(src, idx) in applyDetailLicenseList" :key="idx" class="apply-license-img" :src="src" :preview-src-list="applyDetailLicenseList" fit="cover" />
              </template>
              <span v-else>无</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 订单详情弹窗（采购方发布的订单信息，供应商竞价前查看） -->
    <el-dialog
      top="8vh"
      :append-to-body="true"
      :visible.sync="showOrderDetailDialog"
      width="808px"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="publish-demand-dialog"
      @close="orderDetailInfo = {}"
    >
      <div class="publish-modal" style="padding-bottom: 56px">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="showOrderDetailDialog = false" />
        <h3 class="publish-title">订单详情</h3>
        <div class="bidding-detail">
          <div class="detail-item">
            <span class="detail-label">产品名称：</span>
            <span class="detail-value">{{ orderDetailInfo.productName || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">产品类别：</span>
            <span class="detail-value">{{ orderDetailInfo.productType || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">数量：</span>
            <span class="detail-value">{{ orderDetailInfo.number || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">联系人：</span>
            <span class="detail-value">{{ orderDetailInfo.relationName || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">联系方式：</span>
            <span class="detail-value">{{ orderDetailInfo.relationPhone || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">交货期限：</span>
            <span class="detail-value">{{ orderDetailInfo.deliveryTime || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">付款方式：</span>
            <span class="detail-value">{{ orderDetailInfo.payMethod || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">产品质量：</span>
            <span class="detail-value">{{ orderDetailInfo.productQuality || "无" }}</span>
          </div>
          <div class="detail-item" style="width: 100%">
            <span class="detail-label">订单信息：</span>
            <span class="detail-value">{{ orderDetailInfo.orderInfo || "无" }}</span>
          </div>
          <div class="detail-item" style="width: 100%">
            <span class="detail-label">备注：</span>
            <span class="detail-value">{{ orderDetailInfo.orderRemark || "无" }}</span>
          </div>
          <div class="detail-item" style="width: 100%">
            <span class="detail-label">产品图片：</span>
            <span class="detail-value">
              <template v-if="orderDetailPictureList.length > 0">
                <el-image
                  v-for="(src, idx) in orderDetailPictureList"
                  :key="idx"
                  class="apply-license-img"
                  :src="src"
                  :preview-src-list="orderDetailPictureList"
                  fit="cover"
                />
              </template>
              <span v-else>无</span>
            </span>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 竞价详情弹窗 -->
    <el-dialog
      top="8vh"
      :append-to-body="true"
      :visible.sync="showBiddingDetailDialog"
      width="808px"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="publish-demand-dialog"
      @close="biddingDetailInfo = {}"
    >
      <div class="publish-modal" style="padding-bottom: 56px">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="showBiddingDetailDialog = false" />
        <h3 class="publish-title">竞价申请表单</h3>
        <div style="color: #1869ff; text-align: center; margin-top: 7px; font-size: 16px">
          <span v-if="biddingDetailInfo.biddingStatus == 'bidding'">已竞价</span>
          <span v-else-if="biddingDetailInfo.biddingStatus == 'pass'">通过</span>
          <span v-else-if="biddingDetailInfo.biddingStatus == 'not_pass'">未通过</span>
          <span v-else-if="biddingDetailInfo.biddingStatus == 'close'">终止</span>
        </div>
        <div class="bidding-detail">
          <div class="detail-item">
            <span class="detail-label">产品名称：</span>
            <span class="detail-value">{{ biddingDetailInfo.productName || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">企业名称：</span>
            <span class="detail-value">{{ biddingDetailInfo.enterpriseName || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">联系人：</span>
            <span class="detail-value">{{ biddingDetailInfo.relationName || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">E-mail：</span>
            <span class="detail-value">{{ biddingDetailInfo.mail || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">联系方式：</span>
            <span class="detail-value">{{ biddingDetailInfo.relationPhone || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">地址：</span>
            <span class="detail-value">{{ biddingDetailInfo.address || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">类别：</span>
            <span class="detail-value">{{ biddingDetailInfo.productType || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">数量：</span>
            <span class="detail-value">{{ biddingDetailInfo.number || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">交货期限：</span>
            <span class="detail-value">{{ biddingDetailInfo.deliveryTime || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">单价：</span>
            <span class="detail-value">{{ biddingDetailInfo.price || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">总价：</span>
            <span class="detail-value">{{ biddingDetailInfo.totalAmount || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">付款方式：</span>
            <span class="detail-value">{{ biddingDetailInfo.payMethod || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">产品质量：</span>
            <span class="detail-value">{{ biddingDetailInfo.productQuality || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">备注：</span>
            <span class="detail-value">{{ biddingDetailInfo.biddingRemark || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">审核结果：</span>
            <span class="detail-value">{{ biddingDetailInfo.auditExplain || "无" }}</span>
          </div>
          <div class="detail-item" style="width: 100%">
            <span class="detail-label">产品图片：</span>
            <span class="detail-value">
              <template v-if="biddingDetailPictureList.length > 0">
                <el-image v-for="(src, idx) in biddingDetailPictureList" :key="idx" class="apply-license-img" :src="src" :preview-src-list="biddingDetailPictureList" fit="cover" />
              </template>
              <span v-else>无</span>
            </span>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 修改竞价弹窗 -->
    <el-dialog
      top="8vh"
      :append-to-body="true"
      :visible.sync="showBiddingDialog"
      width="808px"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="publish-demand-dialog"
      @close="handleCloseBiddingDialog"
    >
      <div class="publish-modal">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="showBiddingDialog = false" />
        <h3 class="publish-title">{{ isEditBiddingMode ? "修改竞价" : "提交竞价" }}</h3>
        <div class="publish-form">
          <div class="form-item">
            <span class="form-label">产品名称<i class="required-star">*</i></span>
            <el-input v-model="biddingForm.productName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">产品类别<i class="required-star">*</i></span>
            <el-select v-model="biddingForm.productTypeId" placeholder="请选择" class="form-select" @change="productTypeIdChange">
              <!-- <el-option v-for="item in productTypes" :key="item.value" :label="item.label" :value="item.value" /> -->
              <el-option v-for="item in productTypeList" :key="item.productTypeId" :label="item.typeName" :value="item.productTypeId" />
            </el-select>
          </div>
          <div class="form-item">
            <span class="form-label">数量</span>
            <el-input type="number" v-model="biddingForm.number" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系人</span>
            <el-input v-model="biddingForm.relationName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系方式<i class="required-star">*</i></span>
            <el-input v-model="biddingForm.relationPhone" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">交货期限</span>
            <el-date-picker v-model="biddingForm.deliveryTime" type="date" placeholder="请选择" class="form-date" value-format="yyyy-MM-dd" />
          </div>
          <div class="form-item">
            <span class="form-label">付款方式</span>
            <el-input v-model="biddingForm.payMethod" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">产品质量</span>
            <el-input v-model="biddingForm.productQuality" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">单价<i class="required-star">*</i></span>
            <el-input type="number" v-model="biddingForm.price" placeholder="请输入单价" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">总价<i class="required-star">*</i></span>
            <el-input type="number" v-model="biddingForm.totalAmount" placeholder="请输入优惠总价" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">产品图片</span>
            <ImageUpload v-model="biddingForm.productPicture" :multiple="true" :limit="9" size="120px" dir="product" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">订单信息</span>
            <el-input v-model="biddingForm.orderInfo" type="textarea" placeholder="请输入订单信息" class="form-textarea" :rows="4" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">备注</span>
            <el-input :maxlength="1000" show-word-limit v-model="biddingForm.biddingRemark" type="textarea" placeholder="说点详细信息吧" class="form-textarea" :rows="4" />
          </div>
        </div>

        <div style="text-align: center">
          <button class="publish-submit-btn" @click="submitBidding">{{ isEditBiddingMode ? "修改竞价" : "提交竞价" }}</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDemandDetail,
  getApplyVerifyList,
  getApplyVerifyDetail,
  getBiddingListByDemand,
  closeApplyVerify,
  closeBidding,
  getBiddingDetail,
  submitBidding as submitBiddingApi,
  editBidding,
  getMyProductType,
} from "@/api/demand";
import { getDictData } from "@/api";
import ResultDialog from "@/components/ResultDialog.vue";
import ImageUpload from "@/components/ImageUpload.vue";
import { resolveFileUrl } from "@/utils/oss";

export default {
  name: "RequirementDetails",
  components: {
    ResultDialog,
    ImageUpload,
  },
  data() {
    return {
      isShowMore: true,
      isShowBiddingMore: true,
      avatarImg: require("@/assets/image/avatar.png"),
      demandId: this.$route.query.demandId || null,
      demandType: this.$route.query.type || null, // apply_verify=验样,bidding=竞价
      biddingIdAD: this.$route.query.biddingIdAD || null, // 竞价id如果有的话
      biddingInfoAD: {},
      orderListObj: {},
      personList: [],
      biddingPersonList: [],
      // 终止弹窗
      showTerminateDialog: false,
      terminateReason: "",
      // 验样申请详情弹窗
      showApplyDetailDialog: false,
      applyDetailInfo: {},
      // 订单详情弹窗
      showOrderDetailDialog: false,
      orderDetailInfo: {},
      // 竞价详情弹窗
      showBiddingDetailDialog: false,
      biddingDetailInfo: {},
      // 修改竞价弹窗
      showBiddingDialog: false,
      productTypes: [],
      biddingForm: {
        demandId: "",
        demandOrderId: "",
        productName: "",
        productTypeId: "",
        productType: "",
        number: "",
        relationName: "",
        relationPhone: "",
        deliveryTime: "",
        payMethod: "",
        productQuality: "",
        price: "",
        totalAmount: "",
        productPicture: [],
        orderInfo: "",
        biddingRemark: "",
      },
      productTypeList: [],
    };
  },
  computed: {
    /** 产品图片取第一张 */
    productFirstImage() {
      const pics = this.orderListObj?.productPicture;
      if (!pics) return null;
      return pics.split(",")[0] || null;
    },
    /** 验样详情弹窗营业执照图片列表 */
    applyDetailLicenseList() {
      if (!this.applyDetailInfo || !this.applyDetailInfo.businessLicense) return [];
      const raw = this.applyDetailInfo.businessLicense;
      if (Array.isArray(raw)) return raw.filter(Boolean);
      return String(raw).split(",").filter(Boolean);
    },
    /** 竞价详情弹窗产品图片列表 */
    biddingDetailPictureList() {
      if (!this.biddingDetailInfo || !this.biddingDetailInfo.productPicture) return [];
      const raw = this.biddingDetailInfo.productPicture;
      if (Array.isArray(raw)) return raw.filter(Boolean);
      return String(raw).split(",").filter(Boolean).map((u) => resolveFileUrl(u));
    },
    /** 订单详情弹窗产品图片列表 */
    orderDetailPictureList() {
      if (!this.orderDetailInfo || !this.orderDetailInfo.productPicture) return [];
      const raw = this.orderDetailInfo.productPicture;
      const list = Array.isArray(raw) ? raw.filter(Boolean) : String(raw).split(",").filter(Boolean);
      return list.map((u) => resolveFileUrl(u));
    },
    /** 待竞价 / 竞价中 / 复购竞价：可查看采购方订单详情 */
    canViewOrderDetail() {
      const status = this.orderListObj.demandStatus;
      return (
        this.demandType === "bidding" ||
        status === "bidding" ||
        status === "repurchase_bidding" ||
        !!this.orderListObj.demandOrder ||
        !!this.orderListObj.bidding
      );
    },
    /** 是否为修改竞价模式 */
    isEditBiddingMode() {
      return this.orderListObj.demandStatus === "bidding" && !!this.orderListObj.bidding;
    },
  },
  mounted() {
    this.fetchRequirementDetail();
    this.fetchApplyVerifyList();
    this.fetchBiddingPersonList();
    // this.fetchDict();
    this.getProductTypeListFun();
    this.ADfun();
  },
  methods: {
    ADfun() {
      if (!this.biddingIdAD) {
        return;
      }
      getBiddingDetail(this.biddingIdAD)
        .then((res) => {
          if (res.code == 200) {
            console.log(res);
            this.biddingInfoAD = res.data;
          } else {
            this.$message.error(res.msg || "获取竞价详情失败");
          }
        })
        .catch((error) => {
          this.$message.error(error.message || "获取竞价详情失败");
        });
    },
    productTypeIdChange(id) {
      this.productTypeList.forEach((item) => {
        if (item.productTypeId == id) {
          this.biddingForm.productType = item.typeName;
        }
      });
    },
    getProductTypeListFun() {
      getMyProductType().then((res) => {
        this.productTypeList = res.rows;
      });
    },

    /** 获取需求详情 */
    async fetchRequirementDetail() {
      try {
        // createDemandOrder
        const res = await getDemandDetail(this.demandId);
        if (res && res.code == 200) {
          this.orderListObj = res.data || {};
        }
      } catch (error) {
        console.error("获取需求详情失败：", error);
        this.$message && this.$message.error("获取需求详情失败");
      }
    },
    /** 打开采购方发布的订单详情 */
    async openOrderDetailDialog() {
      let order = this.orderListObj?.demandOrder;
      if (!order && this.demandId) {
        try {
          const res = await getDemandDetail(this.demandId);
          if (res && res.code == 200) {
            this.orderListObj = res.data || this.orderListObj;
            order = this.orderListObj?.demandOrder;
          }
        } catch (e) {
          console.error("刷新订单信息失败：", e);
        }
      }
      if (!order) {
        this.$message.warning("暂无订单信息");
        return;
      }
      this.orderDetailInfo = { ...order };
      this.showOrderDetailDialog = true;
    },
    /** 获取数据字典 */
    fetchDict() {
      getDictData("app_product_type").then((res) => {
        this.productTypes = (res.data || []).map((item) => ({
          label: item.dictLabel,
          value: item.dictValue,
        }));
      });
    },
    /** 获取需求申请验样列表 */
    async fetchApplyVerifyList() {
      try {
        const res = await getApplyVerifyList(this.demandId);
        if (res.code == 200) {
          this.personList = res.rows || [];
        }
      } catch (error) {
        console.error("获取申请验样列表失败：", error);
      }
    },
    /** 获取竞价人员列表 */
    async fetchBiddingPersonList() {
      if (!this.demandId) return;
      try {
        const res = await getBiddingListByDemand(this.demandId);
        if (res.code == 200) {
          this.biddingPersonList = res.rows || [];
        }
      } catch (error) {
        console.error("获取竞价人员列表失败：", error);
      }
    },
    /** 审核结果映射 */
    getApplyStatusLabel(status) {
      const map = {
        apply: "已申请",
        pass: "通过",
        not_pass: "未通过",
        close: "终止",
      };
      return map[status] || status || "无";
    },
    /** 竞价状态映射 */
    getBiddingStatusLabel(status) {
      const map = {
        bidding: "已竞价",
        pass: "通过",
        not_pass: "未通过",
        close: "终止",
      };
      return map[status] || status || "无";
    },
    /** 查看验样申请信息详情 */
    handleViewApply() {
      const applyVerifyId = this.orderListObj?.applyVerify?.applyVerifyId;
      if (!applyVerifyId) {
        this.$message.warning("暂无申请信息");
        return;
      }
      getApplyVerifyDetail(applyVerifyId)
        .then((res) => {
          if (res.code == 200) {
            this.applyDetailInfo = res.data || {};
            this.showApplyDetailDialog = true;
          } else {
            this.$message.error(res.msg || "获取申请信息失败");
          }
        })
        .catch((error) => {
          this.$message.error(error.message || "获取申请信息失败");
        });
    },
    /** 查看竞价详情 */
    handleViewBidding() {
      if (!this.biddingIdAD) {
        this.$message.warning("暂无竞价信息");
        return;
      }
      getBiddingDetail(this.biddingIdAD)
        .then((res) => {
          if (res.code == 200) {
            this.biddingDetailInfo = res.data || {};
            this.showBiddingDetailDialog = true;
          } else {
            this.$message.error(res.msg || "获取竞价详情失败");
          }
        })
        .catch((error) => {
          this.$message.error(error.message || "获取竞价详情失败");
        });
    },
    /** 打开终止弹窗 */
    openTerminateDialog() {
      this.terminateReason = "";
      this.showTerminateDialog = true;
    },
    /** 关闭终止弹窗 */
    closeTerminateDialog() {
      this.terminateReason = "";
    },
    /** 终止验样申请 - 确定 */
    async handleTerminateConfirm() {
      if (!this.terminateReason || !this.terminateReason.trim()) {
        this.$message.warning("请输入终止理由");
        return;
      }
      const applyVerifyId = this.orderListObj?.applyVerify?.applyVerifyId;
      if (!applyVerifyId) {
        this.$message.error("未获取到申请验样ID");
        return;
      }
      try {
        const res = await closeApplyVerify({
          applyVerifyId,
          closeExplain: this.terminateReason,
        });
        if (res.code == 200) {
          this.showTerminateDialog = false;
          this.$message.success("已终止验样申请");
          this.fetchRequirementDetail();
          this.fetchApplyVerifyList();
          this.fetchBiddingPersonList();
        } else {
          this.$message.error(res.msg || "操作失败");
        }
      } catch (error) {
        console.error("终止验样申请失败：", error);
        this.$message.error(error.message || "操作失败");
      }
    },
    /** 取消竞价 */
    handleCloseBidding() {
      this.$confirm("确定要取消竞价吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            const biddingId = this.orderListObj.bidding.biddingId;
            const res = await closeBidding({
              biddingId: biddingId,
              closeExplain: "关闭了",
            });
            if (res.code == 200) {
              this.$message.success("取消竞价成功");
              this.fetchRequirementDetail();
              this.fetchApplyVerifyList();
              location.reload();
            } else {
              this.$message.error(res.msg || "取消竞价失败");
            }
          } catch (error) {
            console.error("取消竞价失败：", error);
            this.$message.error(error.message || "取消竞价失败");
          }
        })
        .catch(() => {
          // 用户取消操作
        });
    },
    /** 获取竞价详细信息（回显表单） */
    openDetailInfo2() {
      const biddingId = this.orderListObj.bidding.biddingId;
      getBiddingDetail(biddingId)
        .then((res) => {
          if (res.code == 200) {
            this.biddingForm.productName = res.data.productName;
            this.biddingForm.productTypeId = res.data.productTypeId;
            this.biddingForm.number = res.data.number;
            this.biddingForm.relationName = res.data.relationName;
            this.biddingForm.relationPhone = res.data.relationPhone;
            this.biddingForm.deliveryTime = res.data.deliveryTime;
            this.biddingForm.payMethod = res.data.payMethod;
            this.biddingForm.productQuality = res.data.productQuality;
            this.biddingForm.price = res.data.price;
            this.biddingForm.totalAmount = res.data.totalAmount;
            this.biddingForm.productPicture = res.data.productPicture ? String(res.data.productPicture).split(",").filter(Boolean) : [];
            this.biddingForm.orderInfo = res.data.orderInfo;
            this.biddingForm.biddingRemark = res.data.biddingRemark;
          } else {
            this.$message.error(res.msg || "获取竞价详情失败");
          }
        })
        .catch((error) => {
          this.$message.error(error.message || "获取竞价详情失败");
        });
    },
    /** 打开提交竞价弹窗 */
    openBiddingDialog() {
      this.resetBiddingForm();
      let userRes = JSON.parse(localStorage.getItem("userRes"));
      this.biddingForm.relationName = userRes.relationName || "";
      this.biddingForm.relationPhone = userRes.relationPhone || "";
      this.biddingForm.productName = this.orderListObj?.productName || "";
      this.biddingForm.productType = this.orderListObj?.productType || "";
      this.biddingForm.productTypeId = this.orderListObj?.productTypeId || "";

      this.biddingForm.demandId = this.demandId;
      this.showBiddingDialog = true;
    },
    /** 打开修改竞价弹窗 */
    openBiddingDialog2() {
      this.biddingForm.demandId = this.demandId;
      if (this.orderListObj.biddingCount != "0") {
        this.openDetailInfo2();
      }
      this.showBiddingDialog = true;
    },
    /** 关闭修改竞价弹窗 */
    handleCloseBiddingDialog() {
      this.showBiddingDialog = false;
      this.resetBiddingForm();
    },
    /** 重置竞价表单 */
    resetBiddingForm() {
      this.biddingForm = {
        demandId: "",
        demandOrderId: "",
        productTypeId: "",
        productName: "",
        productType: "",
        number: "",
        relationName: "",
        relationPhone: "",
        deliveryTime: "",
        payMethod: "",
        productQuality: "",
        price: "",
        totalAmount: "",
        productPicture: [],
        orderInfo: "",
        biddingRemark: "",
      };
    },
    /** 提交/修改竞价 */
    async submitBidding() {
      if (!this.biddingForm.productName || !this.biddingForm.productName.trim()) {
        this.$message.warning("请填写产品名称");
        return;
      }
      if (!this.biddingForm.productTypeId) {
        this.$message.warning("请选择产品类别");
        return;
      }
      if (!this.biddingForm.relationPhone || !this.biddingForm.relationPhone.trim()) {
        this.$message.warning("请填写联系方式");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.biddingForm.relationPhone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      if (!this.biddingForm.price) {
        this.$message.warning("请填写单价");
        return;
      }
      if (!this.biddingForm.totalAmount || !this.biddingForm.totalAmount.trim()) {
        this.$message.warning("请填写总价");
        return;
      }
      const isEdit = this.isEditBiddingMode;
      try {
        const params = {
          ...this.biddingForm,
          demandOrderId: this.orderListObj.demandOrder?.demandOrderId,
          serialNumber: this.orderListObj.demandOrder?.serialNumber,
          productPicture: Array.isArray(this.biddingForm.productPicture) ? this.biddingForm.productPicture.join(",") : this.biddingForm.productPicture,
        };
        if (isEdit) {
          params.biddingId = this.orderListObj.bidding.biddingId;
        }
        const res = isEdit ? await editBidding(params) : await submitBiddingApi(params);
        if (res.code == 200) {
          this.showBiddingDialog = false;
          this.$message.success(isEdit ? "修改竞价成功" : "提交竞价成功");
          this.resetBiddingForm();
          this.fetchRequirementDetail();
          this.fetchApplyVerifyList();
          this.fetchBiddingPersonList();
        } else {
          this.$message.error(res.msg || (isEdit ? "修改竞价失败" : "提交竞价失败"));
        }
      } catch (error) {
        console.error(isEdit ? "修改竞价失败：" : "提交竞价失败：", error);
        this.$message.error(error.message || (isEdit ? "修改竞价失败" : "提交竞价失败"));
      }
    },
  },
};
</script>

<style>
/* 引入产品需求发布弹窗公共样式 */
@import "~@/assets/css/publish-dialog.css";

/* 验样申请信息弹窗内容布局 */
.info-pop-box {
  font-weight: 400;
  margin-top: 35px;
  font-size: 16px;
}
.info-pop-box .row-box {
  display: flex;
  margin-top: 8px;
}
.info-pop-box .row-box:first-child {
  margin-top: 0;
}
.info-pop-box .row-box .row-label {
  color: #999999;
  width: 90px;
  flex-shrink: 0;
  text-align: right;
}
.info-pop-box .row-box .row-value {
  color: #333333;
  padding-left: 10px;
  flex: 1;
  min-width: 0;
  word-break: break-all;
}
.apply-license-img {
  width: 280px;
  height: 200px;
  border-radius: 10px;
  margin-right: 8px;
  margin-bottom: 8px;
}

/* 竞价详情弹窗内容布局 */
.bidding-detail {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 24px;
  align-content: flex-start;
  margin-top: 35px;
}
.detail-item {
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  width: calc(50% - 12px);
}
.detail-label {
  color: #999999;
  width: 80px;
  flex-shrink: 0;
  text-align: right;
}
.detail-value {
  color: #333333;
  padding-left: 8px;
  flex: 1;
  word-break: break-all;
}
</style>

<style scoped>
.requirement-details {
  font-size: 16px;
  color: #999999;

  font-family: Source Han Sans CN, Source Han Sans CN;
}

/* ========== 状态头部 ========== */
.status-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.status-title {
  font-weight: 500;
  font-size: 26px;
  color: #1869ff;
}

.status-btn {
  width: 84px;
  height: 34px;
  background: #1869ff;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  border: none;
}
.status-btn.grey {
  background: #e2e2e2;
  color: #333333;
}

.status-sub {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #666;
  margin-top: 4px;
}

.status-hint {
  font-size: 14px;
}

.status-time {
  font-size: 12px;
}

/* ========== 分区标题 ========== */
.section {
  padding: 30px 22px;
  margin-bottom: 30px;
  background: #ffffff;
  border-radius: 20px;
  line-height: normal;
}
.section:last-child {
  margin-bottom: 0;
}

.section-title {
  display: flex;
  align-items: center;
}

.title-bar {
  background: #1869ff;
  margin-right: 6px;
  flex-shrink: 0;
  border-radius: 100px;
  width: 6px;
  height: 22px;
}

.title-text {
  font-weight: 500;
  font-size: 24px;
  color: #333333;
}
.title-text-num {
  font-weight: 500;
  font-size: 16px;
  color: #999999;
}

/* ========== 人员列表 ========== */
.person-list {
  margin-top: 7px;
}

.person-item {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-bottom: 1px solid #f0f0f0;
  color: #999;
}

.person-company {
  flex: 1;
  min-width: 0;
}

.person-phone {
  display: flex;
  align-items: center;
  width: 300px;
  color: #666666;
  flex-shrink: 0;
}

.phone-icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  flex-shrink: 0;
}

.person-time {
  width: 240px;
  color: #999999;
  text-align: right;
  flex-shrink: 0;
}

/* ========== 验样信息内容 ========== */
.info-content {
  padding: 0 10px;
  margin-top: 10px;
}

.info-row {
  display: flex;
  align-items: flex-start;
  margin-top: 4px;
}

.info-label {
  color: #666666;
}

.info-value {
  color: #666666;
}

.info-link {
  color: #1869ff;
  cursor: pointer;
}
.info-link:hover {
  text-decoration: underline;
}

/* ========== 订单分组表格 ========== */
.table-row {
  display: flex;
  align-items: center;
  padding: 0 9px;
}

.cell {
  padding: 18px 8px 18px 0;
  box-sizing: border-box;
  word-break: break-all;
}

.cell-a {
  width: 14%;
  display: flex;
  align-items: center;
}
.cell-b {
  width: 10%;
}
.cell-c {
  width: 15%;
}
.cell-d {
  width: 9%;
}
.cell-e {
  width: 12%;
}
.cell-f {
  width: 12%;
}
.cell-g {
  width: 16%;
  flex: 1;
}
.cell-action {
  width: 100px;
  flex-shrink: 0;
  text-align: right;
  padding-right: 12px;
}
.order-detail-btn {
  min-width: 84px;
  height: 32px;
  padding: 0 12px;
  background: #1869ff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
.order-detail-btn:hover {
  opacity: 0.9;
}

/* 订单分组 */
.order-group {
  border: 1px solid #ebebeb;
  border-radius: 2px;
  margin-bottom: 10px;
  margin-top: 10px;
  overflow: hidden;
  line-height: 17px;
  color: #666666;
  font-weight: 400;
}

.order-id {
  background: #f7f7f7;
  color: #666666;
  font-size: 12px;
  font-weight: 400;
  padding: 6px 9px;
  border-bottom: 1px solid #ebebeb;
}

.table-body {
  background: #ffffff;
}

/* 发布人 */
.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 6px;
}

/* 产品图占位 */
.product-img {
  width: 48px;
  height: 48px;
  border-radius: 6px;
}
</style>
